(function () {
  let sliders = [];
  let tickerAdded = false;
  let mutationTimeout = null;

  function tick() {
    sliders.forEach((s) => s.update());
  }

  function initCardSliders() {
    sliders.forEach((s) => s.destroy());
    sliders = [];

    document.querySelectorAll('[data-card-slider]').forEach((el) => {
      if (el.children.length < 2) return;

      const slider = new Smooothy(el, {
        infinite: true,
        snap: true,
      });
      slider.init();
      sliders.push(slider);

      const card = el.closest('.card-product-slider');
      if (!card) return;

      const prev = card.querySelector('.card-product-slider__arrow--prev');
      const next = card.querySelector('.card-product-slider__arrow--next');

      if (prev) {
        prev.addEventListener('click', (event) => {
          event.preventDefault();
          slider.goToPrev();
        });
      }

      if (next) {
        next.addEventListener('click', (event) => {
          event.preventDefault();
          slider.goToNext();
        });
      }
    });

    if (sliders.length > 0 && !tickerAdded) {
      gsap.ticker.add(tick);
      tickerAdded = true;
    }
  }

  initCardSliders();

  document.addEventListener('page:loaded', () => initCardSliders());

  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    const observer = new MutationObserver(() => {
      clearTimeout(mutationTimeout);
      mutationTimeout = setTimeout(initCardSliders, 50);
    });
    observer.observe(productGridContainer, { childList: true, subtree: true });
  }
})();
